var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgInsightsIconRecommendationNew = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 10,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3003 22.5H21.3003M15.3003 22.5C15.3003 24.1569 16.6434 25.5 18.3003 25.5C19.9571 25.5 21.3003 24.1569 21.3003 22.5M15.3003 22.5V20.8416C15.3003 20.3512 15.0502 19.9022 14.6939 19.5653C13.6818 18.6083 13.0503 17.2529 13.0503 15.75C13.0503 12.8505 15.4008 10.5 18.3003 10.5C21.1998 10.5 23.5503 12.8505 23.5503 15.75C23.5503 17.2529 22.9188 18.6083 21.9066 19.5653C21.5503 19.9022 21.3003 20.3512 21.3003 20.8416V22.5M16.8003 15.75L18.3003 17.25M18.3003 17.25L19.8003 15.75M18.3003 17.25V22.5",
    stroke: "#6C7DE5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgInsightsIconRecommendationNew);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/insights_icon_recommendation_new.8c0daff4e07d2e0fbca9e0badfd8f45f.svg";